<template>
  <div class="device-list">
    <my-header title="我的设备" back-path="/user"></my-header>
    <div class="container">
      <div class="content">
        <div class="item" v-for="item in devices" :key="item.name" @click="edit(item)">
          <div class="title" v-text="item.name"></div>
          <div>
            <img src="@/assets/images/home/xyy.png"/>
          </div>
        </div>
      </div>
      <div class="remark">
        <img src="@/assets/images/home/zy.png"/>
        <span>点击进行设备基础信息维护。</span>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/HeaderTitle'
import { mapState } from 'vuex'
import basic from '@/model/zone'

export default {
  name: 'DeviceList',
  components: {
    MyHeader
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['zone', 'lights', 'extDevices']),
    devices () {
      return this.lights.map(l => {
        return { id: l.id, name: l.name, alias: l.alias_name, nd: l.nd, type: 'light' }
      }).concat(this.extDevices.map(ext => {
        return { id: ext.id, name: ext.name, alias: ext.alias_name, nd: ext.nd, type: 'ext' }
      }))
    }
  },
  async created () {
    if (!this.zone) {
      await basic.getBasicInfo()
    }
  },
  methods: {
    edit (item) {
      // 跳转，并将信息传递过去
      this.$router.push({ name: 'deviceEdit', params: { device: { ...item } } })
    }
  }
}
</script>

<style scoped lang="less">

.device-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  .container {
    flex: 1;
    position: relative;
    padding: 65px 20px 20px 20px;
    overflow-y: auto;
    & .content {
      border-radius: 4px;
      background-color: white;
      padding: 0px 20px;
      & .item:first-child {
        border: 0px;
      }
      & .item {
        padding: 15px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid rgba(220, 220, 220, .5);
        & .title {
          font-size: 17px;
          font-weight: 600;
          color: rgba(34, 34, 34, 1);
        }
        & img {
          width: 18px;
          cursor: pointer;
        }
      }
    }
    & .remark {
      font-size: 15px;
      font-weight: 400;
      color: rgba(198, 198, 198, 1);
      margin-top: 12px;
      display: flex;
      align-items: flex-start;
      & img {
        width: 18px;
        margin-right: 8px;
        vertical-align: middle;
      }
    }
  }
}
</style>
